export default __webpack_public_path__ + "static/media/how-it-works-5-mob.84c458e1.png";